module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Move case to step","text":"Tasks will be automatically sent to the candidate \\n after moving to another step","select":{"label":"Progress step"}}}')
  delete Component.options._Ctor
}
